import React, { useState, useEffect } from "react";
import * as R from "ramda";

// import Timeline from "@material-ui/lab/Timeline";
// import TimelineConnector from "@material-ui/lab/TimelineConnector";
// import TimelineContent from "@material-ui/lab/TimelineContent";
// import TimelineDot from "@material-ui/lab/TimelineDot";
// import TimelineItem from "@material-ui/lab/TimelineItem";
// import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import { makeStyles } from "@material-ui/core/styles";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

import FileIcon from "ui-kit/FileIcon";
import FileDetails from "./FileDetails";

import { connect } from "react-redux";
import { getters } from "../model";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

import cx from "classnames";

import { getEnableComments } from "../selectors";

const useStyles = makeStyles({
  timelineItemRoot: {
    width: "100%",
    display: "block"
  },
  timelineDotDefaultGrey: {
    marginTop: 0,
    marginBottom: 0
  }
});

const decorate = R.compose(
  connect(state => ({
    isExpanded: getters.expanded(state),
    content: getters.content(state),
    enableComments: getEnableComments(state),
    accentColor: getters.accentColor(state),
    viaPortal: getters.viaPortal(state)
  })),
  CSSModules(css)
);

const History = ({
  file,
  isExpanded = false,
  enableComments,
  accentColor,
  viaPortal
}) => {
  const [isHistoryVisible, setHistoryVisibility] = useState(isExpanded);
  const classes = useStyles();
  useEffect(() => {
    setHistoryVisibility(isExpanded);
  }, [isExpanded]);

  return (
    <div className={cx(css.timeline, { [css.viaPortal]: viaPortal })}>
      <Timeline align="left">
        <TimelineItem>
          <TimelineSeparator>
            <FileIcon bra={1} size={25} mimetype={file.mimetype} />
            {isHistoryVisible && file?.versions?.length > 0 && (
              <TimelineConnector />
            )}
          </TimelineSeparator>
          <TimelineContent
            classes={{
              root: classes.timelineContentRoot
            }}
          >
            <FileDetails
              key={`${file.id}_${isHistoryVisible}`}
              file={file}
              isFirst
              setHistoryVisibility={setHistoryVisibility}
              historyCount={file.versions.length || 0}
              isHistoryVisible={isHistoryVisible}
              enableComments={enableComments}
              accentColor={accentColor}
              viaPortal={viaPortal}
            />
          </TimelineContent>
        </TimelineItem>
        {isHistoryVisible &&
          file.versions &&
          file.versions.map((file, idx, arr) => (
            <TimelineItem>
              <TimelineSeparator className={css.subSeparator}>
                <TimelineDot
                  classes={{ defaultGrey: classes.timelineDotDefaultGrey }}
                />
                {idx !== arr.length - 1 && <TimelineConnector />}
              </TimelineSeparator>
              <TimelineContent
                classes={{
                  root: classes.timelineContentRoot
                }}
              >
                <FileDetails
                  key={`${file.id}_${isHistoryVisible}_${idx}`}
                  file={file}
                  isHistoryVisible={isHistoryVisible}
                  isExpanded={isExpanded}
                  enableComments={enableComments}
                  accentColor={accentColor}
                  viaPortal={viaPortal}
                />
              </TimelineContent>
            </TimelineItem>
          ))}
      </Timeline>
    </div>
  );
};

export default decorate(History);
